/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
/* eslint-disable func-names */
/**
 *
 * config helper
 *
 */

import config from '../config.json';
import { HashSha512 } from './encryptHelper';

export const CONFIG_DETAILS_KEY = 'configDetails';
export const LOCAL_CONFIG_HASH_KEY = 'localConfigHash';
let localConfig;

try {
    localConfig = require('../localConfig').localConfig;
} catch (error) {
    // this just means the file doesn't exist and it's okay
}

export function getServerConfigHashFromLocal() {
    // get the local config if exists and verified. If the config doesn't exist or
    // is corrupted, return null for hash so that we retrieve latest from server
    const storedConfig = getServerConfigObjectFromLocal();
    return storedConfig && storedConfig.configurationHash;
}

export function getServerConfigObjectFromLocal() {
    const storedConfig = localStorage.getItem(CONFIG_DETAILS_KEY);
    if (!storedConfig) return null;
    const validateHash = localStorage.getItem(LOCAL_CONFIG_HASH_KEY);
    if (!validateHash) return null;
    if (validateHash !== HashSha512(storedConfig)) return null;
    return JSON.parse(storedConfig);
}

export function saveServerConfigObjectToLocal(configObject) {
    const configJson = JSON.stringify(configObject);
    localStorage.setItem(CONFIG_DETAILS_KEY, configJson);
    localStorage.setItem(LOCAL_CONFIG_HASH_KEY, HashSha512(configJson));
}

let initialConfig = null;

function convertToKeyValues(obj) {
    const kv = [];
    Object.keys(obj).forEach((k) => {
        kv.push({ Key: k, Value: obj[k] });
    });
    return kv;
}

export function mergeServerConfigIntoLocalConfig(configObject) {
    if (configObject && configObject.configurationNameValues) {
        if (!initialConfig) {
            initialConfig = convertToKeyValues(config);
        }
        const mergedValues = [];
        initialConfig.forEach((kv) => {
            mergedValues.push({ Key: kv.Key, Value: kv.Value });
        });
        const serverConfigValues = JSON.parse(
            configObject.configurationNameValues
        );
        serverConfigValues.forEach((kv) => {
            mergedValues.push({ Key: kv.Key, Value: kv.Value });
        });
        mergedValues.forEach((kv) => {
            config[kv.Key] = kv.Value;
        });

        // only merge in the localConfig if it exists
        if (localConfig !== undefined && localConfig !== null) {
            const localConfigValues = convertToKeyValues(localConfig);
            localConfigValues.forEach((kv) => {
                config[kv.Key] = kv.Value;
            });
        }
    }
    return config;
}

/* Function to return feature flag values
 *
 * @param configObject - stringified array
 * @param configKey - string
 *
 */
export function findConfigFromDataStr(configObject, configKey) {
    if (configObject) {
        let mergedValues = '';

        const serverConfigValues = JSON.parse(configObject);
        serverConfigValues.forEach((kv) => {
            if (kv.Key == configKey) {
                mergedValues = kv.Value;
            }
        });

        return mergedValues == 'true' ? true : false;
    }
}
